import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { selectQuickResponseTemplates } from 'app/utils/reselect';
import * as conversationActions from 'components/conversation/actions/conversation';
import { notificationActions } from 'components/notifications/actions/notification';
import * as personalActions from 'components/settings/actions/personal';
import { templatesActions } from 'components/settings/actions/templates';
import { userModalActions, } from 'components/usersModal';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { withServerStorage } from 'utils/useServerStorage';
import { hasFeature } from '../../featureFlag';
import { composeEmailActions } from '../actions/composeEmailActions';
import { selectInitialValues } from '../selectors/ComposeEmail';
import ComposeEmailModalWithReduxForm, { FORM_NAME, } from './ComposeEmailModal';
const mapStateToProps = (state, props) => {
    const metaConversation = state.composeEmail.parentConversation;
    const rewrittenHtmlEmailMessages = state.emailMessages.messages.filter((message) => { var _a; return message.csid === ((_a = metaConversation === null || metaConversation === void 0 ? void 0 : metaConversation.conversation) === null || _a === void 0 ? void 0 : _a.id); });
    return {
        meta: state.composeEmail.meta,
        ui: state.composeEmail.ui,
        organization: state.settings.organization.organization,
        users: state.composeEmail.users,
        profile: state.settings.profile.profile,
        metaConversation,
        rewrittenHtmlEmailMessages,
        quickResponseTemplates: selectQuickResponseTemplates(state),
        fromEmails: state.composeEmail.fromEmails,
        initialValues: selectInitialValues(state, props.organizationStorage.data),
        formValues: getFormValues(FORM_NAME)(state),
        hasFFWriteHTMLEmail: hasFeature(state, 'write-html-email'),
        isUploadingAttachments: state.richTextField.meta.addAttachments === 'loading' ||
            state.conversationForm.meta.addAttachments === 'loading',
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        composeEmailFindUser: bindActionToPromise(dispatch, composeEmailActions.composeEmailFindUser),
        composeEmailGetAllFrom: bindActionToPromise(dispatch, composeEmailActions.composeEmailGetAllFrom),
        composeEmailAddAttachments: bindActionToPromise(dispatch, composeEmailActions.composeEmailAddAttachments),
        composeEmailSaveDraft: bindActionToPromise(dispatch, composeEmailActions.composeEmailSaveDraft),
        composeEmailRemoveDraft: bindActionToPromise(dispatch, composeEmailActions.composeEmailRemoveDraft),
        composeEmailCloseModal: () => dispatch(composeEmailActions.composeEmailCloseModal()),
        conversationLinkChild: bindActionToPromise(dispatch, conversationActions.actions.conversationLinkChild),
        userModalAddUser: (payload) => dispatch(userModalActions.user.add(payload)),
        userModalGetUser: (payload) => dispatch(userModalActions.user.get(payload)),
        validateEmail: (email) => dispatch(userModalActions.validation.email(email)),
        sendEmail: bindActionToPromise(dispatch, composeEmailActions.composeEmailSend),
        templatesRender: bindActionToPromise(dispatch, templatesActions.templatesRender),
        notificationAdd: (payload) => dispatch(notificationActions.notificationAdd(payload)),
        notificationRemoveById: (payload) => dispatch(notificationActions.notificationRemoveById(payload)),
        updateLastUsedEmailIntegration: bindActionToPromise(dispatch, personalActions.actions.personalLastFromEmailIntegration),
    };
};
export default withServerStorage({
    scope: 'organization',
    propName: 'organizationStorage',
})(connect(mapStateToProps, mapDispatchToProps)(ComposeEmailModalWithReduxForm));
